// init header navigation
export function headerNavigation() {
    let tabletRes = this.tablet;
    let isTabletRes = window.innerWidth < tabletRes;
    let isOpen = false;
    let $headerMenu = $(".js-header-menu");

    $headerMenu.find(".menu-item-has-children").addClass("js-header-menu-item");
    $headerMenu.find(".menu-item-has-children > a").each((index, item) => {
        $(item).append("<span class='arrow-trigger js-header-menu-trigger'></span>");
        $(item).on("click", (e) => {
            let isArrowTrigger = !!$(e.target).closest(".js-header-menu-trigger").length;

            if (isArrowTrigger && (isTabletRes || this.isTouch)) {
                let $container = $(e.target).closest(".menu-item");
                if (isTabletRes) {
                    $container.addClass("is-open")
                        .siblings(".menu-item")
                        .addClass("is-closed");
                } else if (this.isTouch && !isTabletRes) {
                    $container.toggleClass("is-open")
                        .siblings(".menu-item")
                        .removeClass("is-open");
                    isOpen = $container.hasClass("is-open");
                }
                e.preventDefault();
            }
        });
    });
    if (isTabletRes) {
        $headerMenu.find(".menu-item-has-children > ul").each((index, item) => {
            $(item).prepend("<li class='menu-item menu-item-back'><a href='#' class='js-menu-item-back'>back <span class='arrow-trigger'></span></a></li>");
        });
    }
    $(document).on("click", (e) => {
        if (isOpen) {
            let submenu = !!$(e.target).closest(".sub-menu").length;
            let arrowTrigger = !!$(e.target).closest(".js-header-menu-trigger").length;
            if (!submenu && !arrowTrigger && this.isTouch) {
                $(".menu-item").removeClass("is-open");
                isOpen = false;
            }
        }
    });
    $(".js-menu-item-back").on("click", (e) => {
        let $container = $(e.target).closest(".menu-item-has-children");
        $container.removeClass("is-open")
            .siblings(".menu-item")
            .removeClass("is-closed");
        e.preventDefault();
    });
}


export function burgerTrigger() {
    [...document.querySelectorAll(".js-burger")].forEach(item => {
        item.addEventListener("click", (e) => {
            let burgerContainer = e.target.closest(".js-burger-container");
            let body = document.querySelector("body");
            burgerContainer.classList.toggle("is-open");
            let isBodyOpen = burgerContainer.classList.contains("is-open");
            if (isBodyOpen) {
                let offset = window.pageYOffset;
                $.scrollify.disable();
                body.classList.add("is-locked");
                body.style.cssText = "top:"+`${-offset}px`+ " !important;";
                body.dataset.scrollTo = offset;
            } else {
                let scrollToVal = +body.dataset.scrollTo;

                body.classList.remove("is-locked");
                body.style.cssText = "top: '';";

                window.scrollTo( 0, scrollToVal );
                $.scrollify.enable();
            }
            e.preventDefault();
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/header.js